export default __webpack_public_path__ + "media/zurb/img/growth-design/funnels-mobile-3f4d3ad3db13e36b518fb50671fb241a.png";